import { action } from "typesafe-actions";
import { IFailedUploadFetchRequest, IFailedUploadQueryResult, FailedUploadActionTypes } from "./types";

export const fetchRequest = (request: IFailedUploadFetchRequest) => action(FailedUploadActionTypes.FETCH_REQUEST, request);
export const fetchSuccess = (data: IFailedUploadQueryResult) => action(FailedUploadActionTypes.FETCH_SUCCESS, data);
export const fetchError = (message: string) => action(FailedUploadActionTypes.FETCH_ERROR, message);
